import React from "react";
import { Tag } from "lucide-react";
import ComingSoon from "./ComingSoon";

export default function AdminDiscounts() {
    return (
        <ComingSoon
            title="Discount Codes"
            eyebrow="Pricing & Promotions"
            description="Create promo codes, set expiry windows, restrict to specific courses or cohorts. Stripe-aware so codes apply at checkout."
            icon={Tag}
            ctaLabel="+ New Code"
            accent="lime"
            columns={["Code", "Discount", "Scope", "Used / Limit", "Expires", "Status"]}
            mockRows={[
                ["BMG-LAUNCH-50", "50% off", "All courses", "143 / 500", "31 Mar 2026", "Active"],
                ["UNAGENCY-25", "25% off", "Travel Safety", "12 / 100", "30 Jun 2026", "Active"],
                ["SUMMER-200", "£200 off", "HEAT Programme", "0 / 50", "01 Jul 2026", "Scheduled"],
                ["EARLYBIRD-30", "30% off", "All courses", "318 / 318", "31 Dec 2025", "Expired"],
            ]}
        />
    );
}
